<template>
  <div class="logout-btn" @click="logout"><v-icon left>mdi-logout</v-icon>Déconnexion</div>
</template>

<script>
export default {
  name: "Logout",
  methods: {
    logout: function () {
      this.$store.dispatch("logout")
          .then(() => {
            window.location.replace('/connexion');
          })
    }
  },
}
</script>

<style scoped>

</style>